<template>
  <div data-testid="linked-gls">
    <v-simple-table
      dense
      class="mx-2 simple-table border-on radius-small mb-2 linkedgl-table"
      v-if="(tblinkdialogitems || []).length > 0"
      data-testid="linked-gls__table"
    >
      <template v-slot:default>
        <thead data-testid="linked-gls__thead" class="tableHeaderBg">
          <th class="pa-2 tableHeaderBg text-left" data-testid="linked-gls__th-account-no">Account No.</th>
          <th class="pa-2 tableHeaderBg text-left" data-testid="linked-gls__th-type">Type</th>
          <th class="pa-2 tableHeaderBg text-left" data-testid="linked-gls__th-account-name">Account Name</th>
          <th class="pa-2 tableHeaderBg text-right" data-testid="linked-gls__th-opening">Opening</th>
          <th class="pa-2 tableHeaderBg text-right" data-testid="linked-gls__th-transaction">Transaction</th>
          <th class="pa-2 tableHeaderBg text-right" data-testid="linked-gls__th-journal-entries">Journal Entries</th>
          <th class="pa-2 tableHeaderBg text-right" data-testid="linked-gls__th-closing">Closing</th>
        </thead>
        <v-slide-y-transition group tag="tbody" style="overflow: hidden !important" data-testid="linked-gls__tbody">
          <tr v-for="(v, k) in tblinkdialogitems" :key="k" :data-testid="`linked-gls__row-${k}`">
            <td :data-testid="`linked-gls__cell-account-no-${k}`">{{ v.glcode }}</td>
            <td :data-testid="`linked-gls__cell-type-${k}`">{{ v.type }}</td>
            <td :data-testid="`linked-gls__cell-account-name-${k}`">{{ v.name }}</td>
            <td class="text-right" :data-testid="`linked-gls__cell-opening-${k}`">{{ $nova.formatNumber((v.opening_amount || 0).toFixed(0)) }}</td>
            <td class="text-right" :data-testid="`linked-gls__cell-transaction-${k}`">{{ $nova.formatNumber((v.transaction || 0).toFixed(0)) }}</td>
            <td class="text-right" :data-testid="`linked-gls__cell-journal-entries-${k}`">{{ $nova.formatNumber((v.audit_entries || 0).toFixed(0)) }}</td>
            <td class="text-right" :data-testid="`linked-gls__cell-closing-${k}`">{{ $nova.formatNumber((v.closing_amount || 0).toFixed(0)) }}</td>
          </tr>
        </v-slide-y-transition>
      </template>
    </v-simple-table>
    <div v-else class="grey--text px-4 mb-2" data-testid="linked-gls__empty">No Data</div>

    <!-- TaskGLSelection for GL selection -->
    <TaskGLSelection
      data-testid="linked-gls__gl-selection"
      :tbComputed="tbComputed"
      :isUserEditable="isUserEditable"
      :addeditdata="addeditdata"
      :searchcustomfilterLocal="searchcustomfilterLocal"
      :filteredgllist="filteredgllistByLocation"
      @refresh="$emit('refresh')"
      @checklist-item-updated="$emit('checklist-item-updated', $event)"
    />
  </div>
</template>

<script>
import TaskGLSelection from '../../components/TaskGLSelection.vue';

export default {
  name: 'LinkedGLs',
  components: {
    TaskGLSelection
  },
  props: {
    tblinkdialogitems: { type: Array, default: () => [] },
    tbComputed: { type: Array, default: () => [] },
    isUserEditable: { type: Boolean, default: false },
    addeditdata: { type: Object, default: () => ({}) },
    searchcustomfilterLocal: { type: String, default: '' },
    filteredgllist: { type: Array, default: () => [] },
    selectAllgl: { type: Boolean, default: false },
    userLocation: { type: [String, Number], default: '' }
  },
  computed: {
    filteredgllistByLocation() {
      if (this.userLocation && this.filteredgllist && this.filteredgllist.length > 0) {
        return this.filteredgllist.filter(gl => {
          if (!gl.location_detail) return false;
          return gl.location_detail.some(loc => String(loc._id) === String(this.userLocation));
        });
      }
      return this.filteredgllist;
    }
  },
  // ...existing code...
};
</script>

<style>
.linkedgl-table th { font-weight: 500; color: var(--color-hover-text-menu); }
</style>